import { Capacitor } from '@capacitor/core';

export function getPublicAppOrigin(): string {
  const configured = import.meta.env.VITE_PUBLIC_APP_URL?.replace(/\/$/, '');
  if (Capacitor.isNativePlatform() && configured) {
    return configured;
  }
  return window.location.origin;
}
